import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export interface INavigationParms {
  className?: string
}

const useStyles: () => Record<string, string> = makeStyles((theme: Theme) => ({

  boundingRect: {
    fill: '#d9f1fd',
    stroke: '#204284',
    strokeMiterLimit: '10',
    strokeWidth: '20px',
  },

  glassOutline: {
    fill: '#1f4384',
  },

  handle: {
    fill: '#1f4384',
  },

  handleConnector: {
    fill: '#1f4384',
  },

  reflectionOnGlass: {
    fill: '#129cd8',
  },

  reflectionOnHandle: {
    fill: '#e6e7e8',
  },

}));


// By wrapping this component's definition in React.forwardRef, we enable having the ability to accept a React.Ref (ref?) parameter, in addition to the 
// normal 'props' parameter collection. The 'ref' allows us to forward the embedded <svg> element as a DOM reference
const Navigation = React.forwardRef((props: INavigationParms, ref?: React.Ref<SVGSVGElement>) => {

  const { className } = props;
  const classes: Record<string, string> = useStyles();

  return (
    <svg ref={ref} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 520" >
      <defs>
      </defs>
      <g id="NavigationIcon">

        <rect id="BorderAndBackground" className={classes.boundingRect} x="10" y="10" width="500" height="500" rx="10.44" ry="10.44" />

        <g id="MagnifyingGlassWithAdornments">
          <g id="BaseMagnifyingGlass">
            <path id="GlassOutline" className={classes.glassOutline} d="M197.44,334.01c-36.4,0-70.63-14.18-96.37-39.92-25.74-25.74-39.92-59.97-39.92-96.37s14.18-70.63,39.92-96.37c25.74-25.74,59.97-39.92,96.37-39.92s70.63,14.18,96.37,39.92c25.74,25.74,39.92,59.97,39.92,96.37s-14.18,70.63-39.92,96.37c-25.74,25.74-59.97,39.92-96.37,39.92ZM197.44,80.39c-31.34,0-60.8,12.2-82.96,34.37-45.75,45.75-45.75,120.18,0,165.93,22.16,22.16,51.63,34.37,82.96,34.37s60.8-12.2,82.96-34.37c22.16-22.16,34.37-51.62,34.37-82.96s-12.2-60.8-34.37-82.96c-22.16-22.16-51.62-34.37-82.96-34.37Z" />
            <path id="Handle" className={classes.handle} d="M452.94,414.97c10.56,10.56,11.12,27.69.56,38.25h0c-10.56,10.56-27.69,10.56-38.25,0l-93.91-93.35c-10.56-10.56-10.56-27.69,0-38.25h0c10.56-10.56,27.69-10.56,38.25,0l93.35,93.35Z" />
            <path id="HandleConnection" className={classes.handleConnector} d="M357.43,356.91c2.69-2.69,6.02-4.43,9.54-5.22l-76.53-76.53c-.51,4.25-2.37,8.36-5.57,11.56-2.53,2.53-5.63,4.22-8.91,5.07l75.95,75.95s.03.03.04.04c.62-4,2.45-7.84,5.48-10.87Z" />
          </g>
          <path id="ReflectionOnHandle" className={classes.reflectionOnHandle} d="M441.5,430.8c-1.69,0-3.38-.65-4.67-1.94l-91.7-92.12c-2.57-2.58-2.56-6.75.02-9.31,2.58-2.57,6.75-2.55,9.31.02l91.7,92.12c2.57,2.58,2.56,6.75-.02,9.31-1.29,1.28-2.97,1.92-4.65,1.92Z" />
          <path id="ReflectionArcOnGlass" className={classes.reflectionOnGlass} d="M197.27,107.81h.23c29.44.05,57.69,12.69,77.5,34.67.5.55,1.21.87,1.95.87h.12c1.41-.04,2.54-1.2,2.54-2.64,0-.55-.17-1.08-.48-1.52l-.15-.21c-8.71-13.37-20.7-24.51-34.71-32.24-14.31-7.9-30.48-12.09-46.76-12.13h-.14c-16.28,0-32.44,4.15-46.75,12.02-14.12,7.76-26.2,18.98-34.92,32.46-.74,1.15-.47,2.69.61,3.52.46.36,1.02.55,1.6.55.75,0,1.46-.32,1.96-.87,19.84-21.91,48.06-34.48,77.41-34.48Z" />
        </g>

      </g>

    </svg >
  )
});

export default Navigation;
